import React from 'react';
import './ResultsTab.css';

// The "Results" tab — always visible on the voter guide (bottom-left), opens the Election Results page
function ResultsTab() {
  return (
    <a href="/results" className="results-tab" title="2026 Election Results">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
        <line x1="6" y1="20" x2="6" y2="12" /><line x1="12" y1="20" x2="12" y2="5" /><line x1="18" y1="20" x2="18" y2="9" />
      </svg>
      <span>Results</span>
    </a>
  );
}

export default ResultsTab;
